<template>
  <div>
    <form>
      <h3 style="background-color: #f57224;color: white">Temporary Contact Details</h3>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">

        <div class="p-field p-col-12 p-md-4">
          <label for="address1">Address Street 1</label>
          <InputText v-model="tempAddress1" id="address1"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="address2">Address Street 2</label>
          <InputText id="address2" v-model="tempAddress2"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="state">District</label>
          <Dropdown v-model="tempDistrict" optionLabel="key" placeholder="Select One" :options="districtList"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="state">State/Province</label>
          <Dropdown v-model="tempStateNumber" optionLabel="key" placeholder="Select One" :options="stateList"/>
        </div>

        <div class="p-field p-col-12 p-md-4">
          <label for="city">City</label>
          <InputText id="city" v-model="tempCity"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="zip">Zip/Postal Code</label>
          <InputText id="zip" v-model="tempZipNumber"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label>Country</label>
          <Dropdown v-model="tempCountry" optionLabel="key" placeholder="Select One" :options="countryList"/>
        </div>
      </div>
      <hr/>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-4">
          <label for="homeTelephone">Home Telephone</label>
          <InputText id="homeTelephone" v-model="tempHomeTelephone"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="mobile">Mobile</label>
          <InputText id="mobile" v-model="tempMobileNumber"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="workTelephone">Work Telephone</label>
          <InputText id="workTelephone" v-model="tempWorkTelephone"/>
        </div>
      </div>
      <hr/>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-4">
          <label for="workEmail">Work Email</label>
          <InputText id="workEmail" v-model="tempWorkEmail"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="otherEmail">Other Email</label>
          <InputText id="otherEmail" v-model="tempOtherEmail"/>
        </div>
      </div>
      <hr/>
      <div class="p-field-checkbox">
        <label> Is Permanent Address Same?</label>
        <Checkbox id="binary" v-model="isPermanentAddressSame" :binary="true" class="p-ml-4"
                  @change.prevent="setPermanentAddress"/>
      </div>
      <hr/>
      <h3 style="background-color: #f57224;color: white">Permanent Contact Details</h3>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">

        <div class="p-field p-col-12 p-md-4">
          <label for="address1">Address Street 1</label>
          <InputText v-model="perAddress1" id="peraddress1"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="address2">Address Street 2</label>
          <InputText id="peraddress2" v-model="perAddress2"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="state">District</label>
          <Dropdown v-model="perDistrict" optionLabel="key" placeholder="Select One" :options="districtList"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="state">State/Province</label>
          <Dropdown v-model="perStateNumber" optionLabel="key" placeholder="Select One" :options="stateList"/>
        </div>

        <div class="p-field p-col-12 p-md-4">
          <label for="city">City</label>
          <InputText id="percity" v-model="perCity"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="zip">Zip/Postal Code</label>
          <InputText id="perzip" v-model="perZipNumber"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label>Country</label>
          <Dropdown v-model="perCountry" optionLabel="key" placeholder="Select One" :options="countryList"/>
        </div>
      </div>
      <hr/>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-4">
          <label for="homeTelephone">Home Telephone</label>
          <InputText id="perhomeTelephone" v-model="perHomeTelephone"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="mobile">Mobile</label>
          <InputText id="permobile" v-model="perMobileNumber"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="workTelephone">Work Telephone</label>
          <InputText id="perworkTelephone" v-model="perWorkTelephone"/>
        </div>
      </div>
      <hr/>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-4">
          <label for="workEmail">Work Email</label>
          <InputText id="perworkEmail" v-model="perWorkEmail"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="otherEmail">Other Email</label>
          <InputText id="perotherEmail" v-model="perOtherEmail"/>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-1">
          <Button class="p-button-raised" label="Save" icon="pi pi-save"
                  @click.prevent="saveContactDetails"/>
        </div>
        <div class="p-field p-col-12 p-md-1">
          <Button class="p-button-raised p-button-danger" @click.prevent="reset" label="Cancel"/>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'

export default {
  name: 'contactDetails',
  data() {
    return {
      tempAddress1: '',
      tempAddress2: '',
      tempStateNumber: '',
      tempCity: '',
      tempZipNumber: '',
      tempCountry: '',
      tempHomeTelephone: '',
      tempMobileNumber: '',
      tempWorkTelephone: '',
      tempWorkEmail: '',
      tempOtherEmail: '',
      filters: {},
      isPermanentAddressSame: false,
      permanentAddressVal: {},
      tempDistrict: null,
      perAddress1: '',
      perAddress2: '',
      perStateNumber: '',
      perCity: '',
      perZipNumber: '',
      perCountry: '',
      perHomeTelephone: '',
      perMobileNumber: '',
      perWorkTelephone: '',
      perWorkEmail: '',
      perOtherEmail: '',
      perDistrict: null,
      districtList: [{key: 'Bhaktapur', value: 'Bhaktapur'}, {key: 'Kathmandu', value: 'Kathmandu'},
        {key: 'Lalitpur', value: 'Lalitpur'}],
      stateList: [{key: 'Province No. 1', value: '1'}, {key: 'Province No. 2', value: '2'},
        {key: 'Bagmati Province', value: '3'},
        {key: 'Gandaki Province', value: '4'}, {key: 'Lumbini Province', value: '5'},
        {key: 'Karnali Province', value: '6'},
        {key: 'Sudurpashchim Province', value: '7'}],
      countryList: [{key: 'Nepal', value: 'Nepal'}, {key: 'India', value: 'India'}, {key: 'China', value: 'China'}],
      loading: false,
      editing: false
    }
  },
  methods: {
    setPermanentAddress() {
      if (this.isPermanentAddressSame === true) {
        this.perAddress1 = this.tempAddress1
        this.perAddress2 = this.tempAddress2
        this.perStateNumber = this.tempStateNumber
        this.perCity = this.tempCity
        this.perZipNumber = this.tempZipNumber
        this.perCountry = this.tempCountry
        this.perHomeTelephone = this.tempHomeTelephone
        this.perMobileNumber = this.tempMobileNumber
        this.perWorkTelephone = this.tempWorkTelephone
        this.perWorkEmail = this.tempWorkEmail
        this.perOtherEmail = this.tempOtherEmail
        this.perDistrict = this.tempDistrict
      } else {
        this.resetPerAddress()
      }
    },
    saveContactDetails() {
    },
    reset() {
      this.tempAddress1 = ''
      this.tempAddress2 = ''
      this.tempStateNumber = null
      this.tempCity = null
      this.tempZipNumber = ''
      this.tempCountry = null
      this.tempHomeTelephone = ''
      this.tempMobileNumber = ''
      this.tempWorkTelephone = ''
      this.tempWorkEmail = ''
      this.tempOtherEmail = ''
      this.tempDistrict = null
    },
    resetPerAddress() {
      this.perAddress1 = ''
      this.perAddress2 = ''
      this.perDistrict = null
      this.perStateNumber = null
      this.perCity = null
      this.perZipNumber = ''
      this.perCountry = null
      this.perHomeTelephone = ''
      this.perMobileNumber = ''
      this.perWorkTelephone = ''
      this.perWorkEmail = ''
      this.perOtherEmail = ''
    }
  },
  components: {
    Button,
    InputText,
    Dropdown,
    Checkbox
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// contactDetails.vue?20cf9c42